import React, { Suspense } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction } from "../../_actions";
import {
  Drawer,
  Button,
  Divider,
  PageHeader,
  Descriptions,
  message,
} from "antd";
import { VerificationForm } from "./Verification";
const VerifiationListTable = React.lazy(() =>
  import("./VerifiationListTable").then((module) => ({
    default: module.VerifiationListTable,
  }))
);

let columns = [];
let data = [];

class VerificationModule extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    addVerificationModule: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    units: "",
    data: [],
    columns: [],
  };
  userForm = React.createRef();

  componentDidMount() {
    this.getActiveUnits();
    this.getAllocatedVerificationList();
  }

  onOpenAddVerificationDrawer = () => {
    this.setState({
      addVerificationModule: true,
      resetFrom: true,
    });
  };

  onCloseAddVerificationDrawer = () => {
    this.setState({
      addVerificationModule: false,
      resetFrom: false,
    });
  };

  getActiveUnits = () => {
    professionalAction
      .getActiveCities()
      .then((res) => {
        res &&
          res.text().then((response) => {
            let units = JSON.parse(response);
            this.setState({ units: units });
          });
      })
      .catch((err) => {});
  };

  getAllocatedVerificationList = () => {
    professionalAction.AllocatedVerificationList().then((res) => {
      res &&
        res.text().then((response) => {
          let result = JSON.parse(response);

          let columns1 =
            result &&
            result &&
            result.map((itemObj, index) => {
              return {
                ...itemObj,
              };
            });

          let tempObj = columns1.map((res, index) => {
            return {
              ...res,
            };
          });

          this.setState({
            data: tempObj,
          });
        });
    });
  };

  onFormFinish = (values) => {
    const currentDate = new Date();
    const durationYears = parseInt(this.props.values.subscription_duration);

    const expiryDate = new Date(
      currentDate.setFullYear(currentDate.getFullYear() + durationYears)
    )
      .toISOString()
      .split("T")[0];

    const requestData = {
      module_name: values.module_name,
      email: values.email,
      cityId: values.unitName,
      unit_name:
        this.state.units.find((unit) => unit.cityId === values.unitName)
          ?.city_name[0]?.City || "",
      plan: values.plan,
      subscription_duration: values.subscription_duration,
      expiry_date: expiryDate,
    };

    professionalAction
      .saveVerificationAllocation(requestData)
      .then((data) => {
        message.success("Successfully Submitted");
      })
      .catch((error) => {
        console.error("Error in saving verification allocation:", error);
      });
  };

  toggleActiveState = () => {
    this.setState((prevState) => ({
      addVerificationModule: !prevState.addVerificationModule,
    }));
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { pc_cities, basicDistricts } = this.props;

    const roleFour = user && user.role === "4" ? "घटक" : "जिल्हा";

    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            title={user && user.userid}
            subTitle={
              user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
            }
            extra={[
              <Button
                type="primary"
                className="mb-4"
                onClick={this.onOpenAddVerificationDrawer}
              >
                नवीन जोडा
              </Button>,
            ]}
          >
            <Descriptions size="small" column={3}>
              <Descriptions.Item
                label={user && user.role === "8" ? "राज्य" : roleFour}
              >
                {user && user.role === "8"
                  ? "महाराष्ट्र"
                  : "महाराष्ट्र" +
                    " " +
                    "( " +
                    this.getCityName(user && user.cityId) +
                    " )"}
              </Descriptions.Item>
              <Descriptions.Item>
                <span style={{ fontSize: "25px", fontWeight: "600" }}>
                  Verification Module
                </span>
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
        </div>

        <Divider />
        <Drawer
          title="नवीन जोडा"
          placement="right"
          width={720}
          closable={true}
          onClose={this.onCloseAddVerificationDrawer}
          visible={this.state.addVerificationModule}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.onCloseAddVerificationDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              {/* {!this.state.isUpdate ? (
                <Button onClick={this.onFormFinish} type="primary">
                  Save
                </Button>
              ) : (
                <Button onClick={this.onUserFormUpdate} type="primary">
                  Update
                </Button>
              )} */}
            </div>
          }
        >
          <VerificationForm
            ref={this.userForm}
            user={user}
            data={this.state.data}
            units={this.state.units}
            addVerificationModule={this.state.addVerificationModule}
            toggleActive={this.toggleActiveState}
            cityData={pc_cities}
            districtData={basicDistricts}
            users={users}
            onFormFinish={this.onFormFinish}
            getAllocatedVerificationList={this.getAllocatedVerificationList}
          ></VerificationForm>
        </Drawer>
        <Suspense fallback={<div>Loading...</div>}>
          <VerifiationListTable
            onEdituser={this.onEdituser}
            data={this.state.data}
            columns={columns}
            userRole={user}
            units={this.state.units}
            getAllocatedVerificationList={this.getAllocatedVerificationList}
          ></VerifiationListTable>
        </Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    pc_cities,
    basicDistricts,
  };
}

const connectedVerificationModule = connect(mapStateToProps)(
  VerificationModule
);
export { connectedVerificationModule as VerificationModule };
